// src/admin/components/AdminHeader.tsx

import React, { useState, useEffect } from 'react';
import { Bell, Settings, LogOut, MessageSquare } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import { useAdmin } from '../context/AdminContext';
import { adminApi } from '../../utils/api';

export const AdminHeader = () => {
  const navigate = useNavigate();
  const { dispatch } = useAdmin();
  const [unreadMessages, setUnreadMessages] = useState(0);
  const [pendingOrders, setPendingOrders] = useState(0);

  const fetchCounts = async () => {
    try {
      const response = await adminApi.dashboard.getStats();
      setUnreadMessages(response.data.unreadMessagesCount);
      setPendingOrders(response.data.pendingOrdersCount);
    } catch (error: any) {
      console.error('Error fetching counts:', error);
      toast.error(error.message || 'Failed to fetch counts.');
    }
  };

  useEffect(() => {
    fetchCounts();
    // Optionally, set up polling or WebSocket for real-time updates
  }, []);

  const handleLogout = () => {
    dispatch({ type: 'LOGOUT' });
    navigate('/admin/login');
    toast.success('Logged out successfully');
  };

  const handleMessageClick = () => {
    // Navigate to messages page with unread filter
    navigate('/admin/messages?status=unread');
  };

  const handleBellClick = () => {
    // Navigate to orders page with pending filter
    navigate('/admin/orders?shipping_status=pending');
  };

  return (
    <header className="bg-white shadow-sm">
      <div className="flex items-center justify-between h-16 px-6">
        <h1 className="text-xl font-semibold text-gray-800">Shynerz Admin</h1>
        <div className="flex items-center gap-4">
          {/* Message Square Icon */}
          <button
            onClick={handleMessageClick}
            className="p-2 text-gray-500 hover:text-gray-700 rounded-full hover:bg-gray-100 relative"
            title="Unread Messages"
          >
            <MessageSquare className="h-5 w-5" />
            {unreadMessages > 0 && (
              <span className="absolute -top-1 -right-1 bg-pink-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center">
                {unreadMessages}
              </span>
            )}
          </button>

          {/* Bell Icon */}
          <button
            onClick={handleBellClick}
            className="p-2 text-gray-500 hover:text-gray-700 rounded-full hover:bg-gray-100 relative"
            title="Pending Orders"
          >
            <Bell className="h-5 w-5" />
            {pendingOrders > 0 && (
              <span className="absolute -top-1 -right-1 bg-pink-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center">
                {pendingOrders}
              </span>
            )}
          </button>

          {/* Settings Icon */}
          <button
            onClick={() => navigate('/admin/settings')}
            className="p-2 text-gray-500 hover:text-gray-700 rounded-full hover:bg-gray-100"
            title="Settings"
          >
            <Settings className="h-5 w-5" />
          </button>

          {/* Logout Icon */}
          <button
            onClick={handleLogout}
            className="p-2 text-gray-500 hover:text-gray-700 rounded-full hover:bg-gray-100"
            title="Logout"
          >
            <LogOut className="h-5 w-5" />
          </button>
        </div>
      </div>
    </header>
  );
};
